import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type OccupantsDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const OccupantsDetails = ({ control }: OccupantsDetailsProps) => {
  const { errors } = useFormState({ control });

  const { general: { occupants } = {} } = useWatch({
    control,
  });

  const total = isNil(occupants)
    ? null
    : Number(occupants.fullTimeEmployees ?? 0) +
      Number(occupants.visitors ?? 0) +
      Number(occupants.retailCustomers ?? 0) +
      Number(occupants.k12Students ?? 0) +
      Number(occupants.residentialTenants ?? 0);

  const hasError = !!errors.general?.occupants;

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <PeopleIcon fontSize="inherit" />
            <span>&nbsp;Occupants</span>
          </Grid>
        </Typography>
        <Grid container justifyContent="space-between">
          <Typography component="span" variant="body2">
            Total:
          </Typography>
          <Typography
            component="span"
            variant="body2"
            color={
              hasError ? 'error' : isNil(total) ? 'textDisabled' : 'textPrimary'
            }>
            {isNil(total) ? '—' : total}
          </Typography>
        </Grid>
        {!isNil(occupants) && occupants.description !== '' && (
          <Grid container justifyContent="space-between">
            <Typography component="span" variant="body2">
              Description:
            </Typography>
            <Typography component="span" variant="body2" color="textPrimary">
              {occupants.description}
            </Typography>
          </Grid>
        )}
        <Divider />
      </Stack>
    </Box>
  );
};
